import axios from 'axios';
import { baseUrl, apiKey, OVN_API_KEY, OVN_API } from '../config';

const DEFAULT_TEAM = {
  name: "",
   logo: "https://demofree.sirv.com/nope-not-here.jpg"
 };

class  MatchService  {
  constructor() {
  }

  getMatchById =  async (matchId, params = {}) =>  {
    try {
      const response = await axios.get(`${baseUrl}/matches/${matchId}`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params,
      });

      return {
        success: true,
        data: response?.data?.data || response,
      };

    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  }

  getMatchOdds =  async (matchId, params = {}) =>  {
    try {
      const response = await axios.get(`${baseUrl}/matches/${matchId}/odds`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params,
      });

      return {
        success: true,
        data: response?.data?.data || response,
      };
    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  }

  getMatchInsight = async (matchId, params = {}) => {
    try {
      const response = await axios.get(`${baseUrl}/insights/${matchId}`, {
        headers: {
          ["x-signature"]: apiKey,
        },
        params,
      });

      return {
        success: !!response?.data?.success,
        data: response?.data?.data || null,
      };
    } catch (error) {
      console.error(error);
      return { success: false, error: "Server error", data: null };
    }
  }

  getMatchAnalysis =  async (matchId, params = {}) =>  {
    try {
      const response = await axios.get(`${baseUrl}/matches/${matchId}/analysis`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params,
      });

      const jsResponse = response?.data;

      if (!jsResponse.homeTeam) {
        jsResponse.homeTeam = DEFAULT_TEAM;
      }
      if (!jsResponse.awayTeam) {
        jsResponse.awayTeam = DEFAULT_TEAM;
      }

      return jsResponse;
    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  }

  getMatchHalfFullAnalysis =  async (matchId, params = {}) =>  {
    try {
      const response = await axios.get(`${baseUrl}/matches/${matchId}/half-full-analysis`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params,
      });

      return response?.data?.data;

    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  }

  getHeatMapData =  async (isLive, queryObject) =>  {
    try {
      const params = new URLSearchParams({
        home: queryObject?.homeName,
        away: queryObject?.awayName,
        date: queryObject?.date,
        "api-key": OVN_API_KEY,
      });

      if(!isLive) {
        return  null;
      }

      
      const response = await axios.get(`${OVN_API}/v1/fixture-detail?${params}`, {
        headers: {
          ['x-signature']: apiKey,
        },
      });

      return response?.data?.response?.detail?.detail?.flash_live || null;
      
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  getLiveOddByMatchId =  async (matchId) =>  {
    try {
      const response = await axios.get(`${baseUrl}/odd/${matchId}/live`, {
        headers: {
          ["x-signature"]: apiKey,
        }
      });
      
      return response?.data?.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  getOddByMatchId =  async (matchId) =>  {
    try {
      const response = await axios.get(`${baseUrl}/odd/${matchId}`, {
        headers: {
          ["x-signature"]: apiKey,
        }
      });
      return response?.data?.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  getMatchComparison =  async (matchId) =>  {
    try {
      const response = await axios.get(`${baseUrl}/matches/${matchId}/strength-comparison`, {
        headers: {
          ["x-signature"]: apiKey,
        }
      });
      return response?.data?.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }


  getMatchGoalStats =  async (matchId) =>  {
    try {
      const response = await axios.get(`${baseUrl}/matches/${matchId}/goals-stats`, {
        headers: {
          ["x-signature"]: apiKey,
        }
      });
      return response?.data?.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  getMatchOddStats =  async (matchId) =>  {
    try {
      const response = await axios.get(`${baseUrl}/matches/${matchId}/odds-stats`, {
        headers: {
          ["x-signature"]: apiKey,
        }
      });
      return response?.data?.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  getMatchLatest =  async (matchId, homeId, awayId) => {
    try {
      const response = await axios.get(`${baseUrl}/matches/last-matches?homeId=${homeId}&awayId=${awayId}&matchId=${matchId}`, {
        headers: {
          ["x-signature"]: apiKey,
        }
      });
      return response?.data?.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  getMatchLineups = async (matchId, homeId, awayId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/matches/line-up-last-match?matchId=${matchId}&homeId=${homeId}&awayId=${awayId}`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
        }
      );
      const jsResponse = response?.data?.data;
      return jsResponse;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  getMatchFormStats = async (matchId, teamIds) => {
    try {
      const response = await axios.get(
        `${baseUrl}/matches/${matchId}/form-stats?teamIds=${teamIds}`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
        }
      );
      const jsResponse = response?.data?.data;
      return jsResponse;
    } catch (error) {
      console.error(error);
      return {};
    }
  }
}


const instance = new MatchService();
export { instance as MatchService };